import actionCreator from 'helpers/actionCreator'
import { APPLY_PROJECTS, EXPAND_PROJECT, CREATE_PROJECT,
         ADD_PROJECT, CHANGE_PROJECT, DESTROY_PROJECT,
         REMOVE_PROJECT, UPDATE_PROJECT,
         MERGE_PERMALINK_PROJECT,
         APPLY_LEGACY_PROJECTS, MIGRATE_LEGACY_PROJECT,
         CHANGE_PROJECT_FROM_STARTUP, MARK_LEGACY_PROJECT_HIDDEN,
         REMOVE_LEGACY_PROJECT, PARTIALLY_APPLY_PROJECTS, DUPLICATE_PROJECT,
         CLEAR_PROJECTS, SELECT_PROJECT, CREATE_MOBILE_PROJECT,
         CREATE_PROJECT_FROM_STARTUP } from 'actions/projectActionTypes'

export const applyProjectsAction = actionCreator(APPLY_PROJECTS, 'projects')
export const partiallyApplyProjectsAction = actionCreator(PARTIALLY_APPLY_PROJECTS, 'projects')
export const expandProjectAction = actionCreator(EXPAND_PROJECT, 'project', 'offline', 'active', 'permalink', 'settings')
export const createProjectAction = actionCreator(CREATE_PROJECT)
export const addProjectAction = actionCreator(ADD_PROJECT, 'project')
export const changeProjectAction = actionCreator(CHANGE_PROJECT, 'id')
export const destroyProjectAction = actionCreator(DESTROY_PROJECT, 'id')
export const removeProjectAction = actionCreator(REMOVE_PROJECT, 'id')
export const updateProjectAction = actionCreator(UPDATE_PROJECT, 'updates')
export const mergePermalinkProjectAction = actionCreator(MERGE_PERMALINK_PROJECT)
export const applyLegacyProjectAction = actionCreator(APPLY_LEGACY_PROJECTS, 'projects')
export const migrateLegacyProject = actionCreator(MIGRATE_LEGACY_PROJECT, 'project')
export const changeProjectFromStartupAction = actionCreator(CHANGE_PROJECT_FROM_STARTUP, 'id')
export const createProjectFromStartupAction = actionCreator(CREATE_PROJECT_FROM_STARTUP)
export const markLegacyProjectHiddenAction = actionCreator(MARK_LEGACY_PROJECT_HIDDEN, 'uniqueKey')
export const removeLegacyProjectAction = actionCreator(REMOVE_LEGACY_PROJECT, 'uniqueKey')
export const duplicateProjectAction = actionCreator(DUPLICATE_PROJECT)
export const clearProjectsAction = actionCreator(CLEAR_PROJECTS)
export const selectProjectAction = actionCreator(SELECT_PROJECT, 'id')
export const createMobileProjectAction = actionCreator(CREATE_MOBILE_PROJECT, 'location', 'zoom')



// WEBPACK FOOTER //
// ./src/actions/projectActions.js